export default __webpack_public_path__ + "static/media/alcohol_book.c0ed8a79.svg";